<template>
  <div class="m-content">
    <HeaderBox/>
    <div class="report-content">
      <div class="report-area">
        <p class="know-text">答对：<span class="know-num">{{result.rightNum}}</span>题</p>
        <p class="know-text">你打败了<span class="know-percent">{{result.exceedPercent}}%</span>的闯关者</p>
      </div>
      <div class="report-area">
        <p class="user-title">排行榜</p>
        <div class="user-list">
          <div class="user-text" v-for="(list,index) in result.listUserResult">
            <p class="left-side">{{list.user.studentCollege}}{{list.user.studentName}}</p>
            <p class="right-side">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-check"></use>
              </svg>
              {{list.rightNum}}题
            </p>
          </div>
        </div>
      </div>
    </div>
   <FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'KnowlegeReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      result:''
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-我的决策产生记')
    this.getReport()
  },
  methods:{
    // 获取报告信息将值传给data
    getReport(result){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosGraduateReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            const result = response.data.data;
            if(result){
               this.result=result.cosGraduate;
               // 弹幕
               let text='',score =parseInt(this.rightNum*2.27)
               if(this.result.rightNum>=12){
                 text = '居然答对了'+this.result.rightNum+'题，Unbelievable'
               }else if(this.result.exceedPercent>=60){
                 text = '已经打败了'+this.result.exceedPercent+'%的闯关者'
               }else if(score>=60){
                 text = '获得了'+score+'分'
               }
               if(text){
                 store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
               }
             }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    }
  }
}
</script>
<style scoped>
</style>
